import type { SingleIconProps } from "./icon"

const ArrowLeftIcon = (props: SingleIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.89 5L6.3 11.24H21V13.6H6.3L10.89 19.84H8.07L2.65 12.42L8.07 5H10.89Z"
        fill="#081F42"
      />
    </svg>
  )
}

export { ArrowLeftIcon }
